import { useQuery } from '@tanstack/react-query';
import { apiGet, ApiError } from '@/lib/api';
import type { AutoCampaignStatus } from './types';

/**
 * Poll the auto-campaign status for a project. Refreshes every 30s while the
 * user is on an auto-campaign page — the linked chat count and last-fire
 * pointer can change out-of-band (Telegram webhook, tick workflow).
 */
export function useAutoCampaignStatus(projectId: string | undefined) {
  return useQuery({
    queryKey: ['auto-campaign', 'status', projectId],
    queryFn: () =>
      apiGet<AutoCampaignStatus>(
        `/v1/projects/${projectId}/auto-campaign/status`,
      ),
    enabled: Boolean(projectId),
    refetchInterval: 30_000,
    // Suppress retry on 404 — the project was deleted or doesn't belong to
    // this tenant. Retrying floods the log.
    retry: (failureCount, err) => {
      if (err instanceof ApiError && err.status === 404) return false;
      return failureCount < 2;
    },
  });
}
